import { createFileRoute } from "@tanstack/react-router"
import { usePageTracking } from "../../../../../hooks/usePageTracking"
import IncomingOrdersOverview from "~/components/purchaseOrder/incomingOrders/IncomingOrdersOverview"

export const Route = createFileRoute("/_auth/procurement/incoming-orders/_layout/list")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Incoming Orders List")
  return <IncomingOrdersOverview />
}
